import { GlobalAppState } from '@model/state';

export const getSeatMaps = (state: GlobalAppState) => state.seatMaps.data;
export const getSeatMapsLoading = (state: GlobalAppState) => state.seatMaps.loading;
